export const getDefaultValues = (avatarDetails) => ({
  AvatarTitle: avatarDetails?.AvatarTitle || '',
  AvatarURLPreview: avatarDetails?.AvatarURLPreview || '',
  AvatarURLOriginal: avatarDetails?.AvatarURLOriginal || '',
  AvatarEnable: avatarDetails?.AvatarEnable || '',
  AvatarAmountOriginal: avatarDetails?.AvatarAmountOriginal || '',
  AvatarDiscountPercent: avatarDetails?.AvatarDiscountPercent || 0,
  AvatarAmountFinal: avatarDetails?.AvatarAmountFinal || '',
  AvatarTransactionAmountTypeID: avatarDetails?.AvatarTransactionAmountTypeID || '',
});
